export default "__VITE_PUBLIC_ASSET__cd3a3951__"